import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { positionApplicantsCountRoute } from '../api/constant';

type useGetHiredApplicantsCountProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  position_ids: string;
};

export const useGetHiredApplicantsCount = ({
  setErrorText = () => {},
  position_ids,
}: useGetHiredApplicantsCountProps) => {
  const { data: applicantsCount, isFetching: isLoadingApplicantsCount } =
    useQuery({
      queryKey: [position_ids],
      enabled: Boolean(position_ids),
      queryFn: () => {
        return axiosInstance
          .get(`${positionApplicantsCountRoute}?position_ids=${position_ids}`)
          .then((res) => res.data);
      },
      onSuccess: (data) => {
        if (data.object) {
          setErrorText('');
        }
        if (data.status !== 200) {
          setErrorText(data.message);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
      refetchOnWindowFocus: false,
    });

  return {
    applicantsCount,
    isLoadingApplicantsCount,
  };
};
